import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/area-externa';

/**
 * GET Áreas Externas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getAreasExternas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Área Externa
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getAreaExterna = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Área Externa
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postAreaExterna = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Área Externa
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchAreaExterna = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Área Externa
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteAreaExterna = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Área Externa
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarAreaExterna = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/autorizar`);
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
